import {
  Subscription,
} from '../../../models';
import { useQuery } from '../../../routes';
import { ProductGroup } from '../../plan';
import { SubscriptionTableView } from './SubscriptionTableView';
import { SubscriptionFlexView } from './SubscriptionFlexView';

enum ViewMode {
  TABLE = 'table',
  FLEX = 'flex',
}

export const SubscriptionGroup = (
  { groupId, color, subscriptions }: {
    groupId: string;
    color: string;
    subscriptions: Subscription[];
  },
) => {
  if (!subscriptions || subscriptions.length === 0) {
    return null;
  }

  const { get } = useQuery();
  const viewMode = get('viewMode')?.toLowerCase() ?? ViewMode.FLEX.toLowerCase();

  const renderSubscriptionView = () => {
    switch (viewMode.toLowerCase()) {
      case ViewMode.FLEX.toLowerCase():
        return (
          <SubscriptionFlexView
            groupId={groupId}
            color={color}
            subscriptions={subscriptions}
          />
        );
      case ViewMode.TABLE.toLowerCase():
      default:
        return (
          <ProductGroup groupId={groupId} color={color}>
            <SubscriptionTableView
              groupId={groupId}
              subscriptions={subscriptions}
            />
          </ProductGroup>
        );
    }
  };
  return (
    <>
      {renderSubscriptionView()}
    </>
  );
};
